/* Copyright (c) 2018-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

export interface OS {
    OSName: string;
    OSVersion: string;
    Platform: string;
}

export enum OSTypes {
    Windows = 'Windows',
    Mac = 'Mac',
    Linux = 'Linux'
}
